var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._b({staticClass:"binds-list-item-link"},'a',_vm.$props,false),[_c('binds-list-item-content',{attrs:{"binds-disabled":_vm.isDisabled}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }